import { useEffect, useState } from "react";
import axios from "axios";
import { useRecoilState, useRecoilValue } from "recoil";
import { appVersion, userState } from "../states/userState";
import { User, Filters, Columns, TableParams } from "../components/types/user";

import {
  getUserFromLocalStorage,
  setUserToLocalStorage,
} from "../functions/localStorageManager";
import { auth, provider } from "../firebase";
import {
  signInWithPopup,
  signInWithRedirect,
  getRedirectResult,
} from "firebase/auth";
import { modeState } from "../states/modeState";
import { VIEW_ID_ALL_FACTORY } from "../commons/views";
import { getDefaultCheckedItems } from "../commons/productItems";
//全ユーザー一覧を取得するカスタムフック
//呼び出し先の記述
//const {getUsers, userProfiles, loading, error} = useAllUsers();

export const useLogin = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [user, setUser] = useRecoilState(userState);
  const mode = useRecoilValue(modeState);
  /**
   * 0:成功、1:Google認証エラー、2:kintone照合エラー
   */
  const loginWithGoogle = async () => {
    //Google認証を実行
    const result = await signInWithGoogle();

    if (!result) return 1;
    const googleUser = result.user;
    // // 必要なユーザー情報を抽出
    // const uid = googleUser.uid;
    const photoURL = googleUser.photoURL ?? "";
    const displayName = googleUser.displayName ?? "";
    const email = googleUser.email ?? "";

    const defaultFilterParams: Filters = {
      salesNo: "", // 空文字列で初期化
      productNo: "", // 空文字列で初期化
      factory: [50], // 空の配列で初期化
      situation: [0], // 空の配列で初期化
      office: [0],
      field: [0],
      productItem: getDefaultCheckedItems(VIEW_ID_ALL_FACTORY),
    };
    const defaultTableParams: TableParams = {
      selectedPage: 1,
      junmpPage: "1",
      selectedDisplayNumber: 20,
      keywords: "",
      sorting: [],
      columnFilters: [],
    };

    const loginUser: User = {
      appVersion: appVersion,
      isAuth: true,
      workerId: 0,
      viewId: 0,
      mode: mode,
      workerName: displayName,
      mail: email,
      photoURL: photoURL,
      columnsAllFactory: Array<Columns>(), // カラム情報を空配列で初期化
      columnsPT: Array<Columns>(), // カラム情報を空配列で初期化
      columnsPV: Array<Columns>(), // カラム情報を空配列で初期化
      columnsKanto: Array<Columns>(), // カラム情報を空配列で初期化
      columnsFukuokaKumamoto: Array<Columns>(), // カラム情報を空配列で初期化
      columnsSite: Array<Columns>(),
      filters: defaultFilterParams,
      tableParams: defaultTableParams,
    };

    //Recoilにユーザ情報をセット
    setUser(loginUser);
    //LocalStorageにユーザ情報をセット
    setUserToLocalStorage(loginUser);

    return 0;
  };

  return { loginWithGoogle, loading, error };
};

const signInWithGoogle = async () => {
  try {
    const result = await signInWithPopup(auth, provider); // Google認証を試みる
    return result; // 認証が成功した場合はtrueを返す
  } catch (error: any) {
    alert(error.message); // エラーメッセージを表示
    return false; // 認証が失敗した場合はfalseを返す
  }
};

// const signInWithGoogle = async () => {
//   try {
//     await signInWithRedirect(auth, provider); // Google認証を試みる
//     const result = await getRedirectResult(auth);
//     return result; // 認証が成功した場合はtrueを返す
//   } catch (error) {
//     alert(error.message); // エラーメッセージを表示
//     return false; // 認証が失敗した場合はfalseを返す
//   }
// };

// const getUserFromKintone = async (email) => {
//   try {
//     const result = await axios.get(
//       `https://kintoneconnect-6ywpmfhxlq-an.a.run.app/api/next/nextuser/${email}`
//     );
//     return result.data; // 認証が成功した場合はtrueを返す
//   } catch (error) {
//     alert(error.message); // エラーメッセージを表示
//     return false; // 認証が失敗した場合はfalseを返す
//   }
// };
